import { useCustomFields } from '@/composables/useCustomFields'

const getRawValue = (unit, fieldKey) => {
    let raw = unit[fieldKey]
    if (typeof raw === 'number') {
        return raw
    }

    if (unit.rowData) {
        raw = unit.rowData[fieldKey]
    }
    if (raw !== undefined || raw !== null || typeof raw === 'number') {
        return raw
    }

    if (unit.customColumnValues) {
        raw = unit.customColumnValues[fieldKey]
    }
    if (raw !== undefined || raw !== null || typeof raw === 'number') {
        return raw
    }

    return undefined
}

export function useCustomFieldRenderer(project, unit, fieldKey) {
    const { getField, getFieldStatusOption, renderWithTypeAndAffixes, renderWithType } =
        useCustomFields()

    const raw = getRawValue(unit, fieldKey)

    const field = getField(project, fieldKey)
    const typed = renderWithType(project, fieldKey, raw)
    const full = renderWithTypeAndAffixes(project, fieldKey, raw)

    const { $getI18n } = useNuxtApp()

    const prefix = $getI18n(field.prefix)
    const suffix = $getI18n(field.suffix)

    const { customRenderer, hideRenderer, hide } = getFieldStatusOption(project, unit, fieldKey)

    return {
        field,
        raw,
        typed,
        full,
        prefix,
        suffix,
        customRenderer,
        hideRenderer,
        hasPrefix: !!prefix,
        hasSuffix: !!suffix,
        hasCustomRenderer: !!customRenderer,
        hasHideRenderer: !!hideRenderer,
        isHidden: !!hide
    }
}
